// 受保护路由守卫（注入式下沉 · FE2-018）：无会话 → 跳注入的 loginPath() 并记录来源；有 → 渲染 <Outlet/>。
//
// shared 不 import 门户代码（@/api/client、@/i18n 均为端内实现），故会话读取与
// 登录路径规则由各端壳注入：
//   - isAuthenticated：必填，各端注入自身 loadSession 会话判定（admin/agent/merchant
//     判定式与原实现 `!session?.accessToken` 等价）；
//   - loginPath：必填，admin/agent/merchant 注入固定 '/login'；customer 注入
//     localePath('/login', resolved)（{lang} 前缀规则）。
import { Navigate, Outlet, useLocation } from 'react-router-dom';

export interface RequireAuthProps {
  /** 会话判定（各端注入，如 () => Boolean(loadSession()?.accessToken)） */
  isAuthenticated: () => boolean;
  /** 登录跳转路径（各端注入：固定 '/login' 或 customer 的 '/{lang}/login' 规则） */
  loginPath: () => string;
}

export default function RequireAuth({ isAuthenticated, loginPath }: RequireAuthProps) {
  const location = useLocation();
  if (!isAuthenticated()) {
    return <Navigate to={loginPath()} state={{ from: location.pathname }} replace={true} />;
  }
  return <Outlet />;
}
